"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
var _Button = require("@ccw-pwa-ui/Button");
require("./SideMenu.scss");
var _reactBootstrap = require("react-bootstrap");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SideMenu = props => {
  const {
    NavItems,
    onClick,
    style,
    sideBarOneStyle,
    closeButtonIcon,
    isDesktop,
    isPortrait,
    version,
    userScreenPrefDispatcher
  } = props;
  const getButtonJSX = (navItem, isDesktop, key) => {
    let items = null;
    switch (navItem.Component) {
      case 'HeaderText':
        items = /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
          key: navItem.title + key,
          headerText: navItem.title,
          variant: navItem.variant,
          headerStyle: navItem.style
        });
        break;
      case 'Text':
        items = /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
          key: navItem.title + key,
          headerText: navItem.title,
          variant: navItem.variant,
          headerStyle: navItem.style
        });
        break;
      case 'Button':
        items = /*#__PURE__*/_react.default.createElement("div", {
          style: isDesktop || userScreenPrefDispatcher ? navItem.clickedTile : null
        }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
          key: navItem.title + key,
          title: navItem.title,
          icon: navItem.leftIcon,
          variant: navItem.variant,
          className: navItem.variant,
          buttonStyle: isDesktop || userScreenPrefDispatcher ? navItem.style : navItem.mobStyle,
          rightIcon: navItem.rightIcon,
          onClick: navItem.onClick,
          redirect: navItem.redirect,
          redirectText: navItem.redirectText,
          url: navItem.url
        }));
        break;
      case 'hr':
        if (0) {
          items = navItem.tag;
        }
        break;
      default:
        break;
    }
    return items;
  };
  const manipulateNavItemData = (NavItems, isDesktop) => {
    return [NavItems[0].map((navItem, key) => {
      return getButtonJSX(navItem, isDesktop, key);
    }), /*#__PURE__*/_react.default.createElement("div", {
      key: "sidebar-key1",
      className: "d-flex flex-column align-items-center",
      style: sideBarOneStyle
    }, NavItems[1].map((navItem, key) => {
      return getButtonJSX(navItem, isDesktop, key);
    })), /*#__PURE__*/_react.default.createElement("div", {
      key: "sidebar-key2",
      className: "d-flex flex-column align-items-center",
      style: {
        width: '100%',
        bottom: '100%'
      }
    }, NavItems[2].map((navItem, key) => {
      return getButtonJSX(navItem, isDesktop, key);
    }))];
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, props.menuState && /*#__PURE__*/_react.default.createElement("div", {
    onClick: onClick
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: props.menuState ? "Side-Panel tablet-view active" : "Side-Panel tablet-view hide-menu",
    style: style
  }, isDesktop && !isPortrait && /*#__PURE__*/_react.default.createElement("div", {
    key: 'desktop',
    className: "d-flex flex-column p-0 bg-light ",
    style: {
      width: '252px',
      height: '100%',
      alignItems: 'center'
    }
  }, manipulateNavItemData(NavItems, isDesktop), version), /*#__PURE__*/_react.default.createElement("div", {
    key: 'mobile',
    className: "d-flex flex-column p-0 bg-light ",
    style: {
      width: '252px',
      height: '100%',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: " d-flex flex-column align-self-end  p-3"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Image, {
    src: closeButtonIcon,
    style: {
      width: '24px'
    },
    onClick: onClick
  })), manipulateNavItemData(NavItems, isDesktop), version)));
};
SideMenu.defaultProps = {
  sideBarOneStyle: {
    width: '100%'
  }
};
var _default = exports.default = SideMenu;